export const PROJECT_SECTIONS = [
  'overview',
  'prompts',
  'knowledge',
  'chunk-links',
  'products',
  'conversations',
  'leads',
  'widget',
  'fine-tuning',
  'integrations',
  'training',
  'settings',
  'policy',
  'audit',
] as const

export type ProjectSection = (typeof PROJECT_SECTIONS)[number]

const TAB_TO_SECTION: Record<string, ProjectSection> = {
  overview: 'overview',
  prompts: 'prompts',
  chat: 'conversations',
  leads: 'leads',
  knowledge: 'knowledge',
  catalog: 'knowledge', // legacy-алиас старого normalizeTab (catalog → knowledge)
  products: 'products',
  embed: 'widget',
  integrations: 'integrations',
  training: 'training',
  settings: 'settings',
  consent: 'policy',
}

export function legacyTabToSection(tab: string | null): ProjectSection {
  return (tab && TAB_TO_SECTION[tab]) || 'overview'
}

export function projectSectionPath(projectId: string, section: ProjectSection): string {
  return `/projects/${projectId}/${section}`
}

export function isProjectSection(value: string): value is ProjectSection {
  return (PROJECT_SECTIONS as readonly string[]).includes(value)
}
